module.exports = __webpack_public_path__ + "img/path.cfafe51d.svg";